// import { getUrl, requests } from "../../globals/requests";
import {
  GET_USERS,
  LOADING_GET_USERS,
  REMOVE_USER,
  SET_USER,
  UPDATE_USER,
} from "../types";

import { requests, getUrl } from "../../globals/requests";

export const setUser = (payload) => {
  return {
    type: SET_USER,
    payload: payload,
  };
};
export const updateUser = (id, payload) => {
  return {
    type: UPDATE_USER,
    id,
    payload: payload,
  };
};

export const getUsers = (query) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("users")}`;
      dispatch({
        type: LOADING_GET_USERS,
        payload: true,
      });
      const response = await requests.getWithAuth(url, query);

      dispatch({
        type: LOADING_GET_USERS,
        payload: false,
      });

      dispatch({
        type: GET_USERS,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      console.log(e);
      dispatch({
        type: LOADING_GET_USERS,
        payload: false,
      });
      throw e;
    }
  };
};
export const getUser = (id) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("users")}/${id}`;

      const response = await requests.getWithAuth(url);

      dispatch({
        type: SET_USER,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};
export const deleteUser = (id) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("users")}/${id}`;
      // dispatch({
      //   type: LOADING_GET_USERS,
      //   payload: true,
      // });
      const response = await requests.deleteWithAuth(url);

      // dispatch({
      //   type: LOADING_GET_USERS,
      //   payload: false,
      // });

      dispatch({
        type: REMOVE_USER,
        payload: id,
      });

      return response.data;
    } catch (e) {
      console.log(e);
      // dispatch({
      //   type: LOADING_GET_USERS,
      //   payload: false,
      // });
      throw e;
    }
  };
};
